import { Route, NavigationGuard, RawLocation } from 'vue-router'

import store from '@/system/store'
import { GET_USER } from '@/system/store/getter-types'
import { FETCH_CUSTOMERS } from '@/system/store/action-types'
import { ALLOWED_ROLES } from '@/constants'
import { authLocalisationKeys } from '@/features/auth/auth.localisation'

const checkRole = async (): Promise<void> => {
  const { role } = store.getters[GET_USER]

  if (!ALLOWED_ROLES.includes(role)) throw new Error(authLocalisationKeys.ACCESS_DENIED)

  return Promise.resolve()
}

const fetchCustomers = async (): Promise<void> => {
  await store.dispatch(FETCH_CUSTOMERS)
}

export const CheckRoleGuard: NavigationGuard = async (
  to: Route,
  from: Route,
  next: (to?: RawLocation) => void
): Promise<any> => Promise
  .all([
    checkRole(),
    fetchCustomers()
  ])
  .then(_ => next())
